module.exports = __webpack_public_path__ + "static/logo-341eba32a715604b47a10b9670a8151f.svg";